import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const GetAllSupportMessagesService = (page = 1, limit = 10) => {
  return HTTP_CLIENT.get(
    `${Endpoint.support.getAllSupportMessages}?page=${page}&limit=${limit}`
  );
};
const DeleteSupportMessageService = (messageId: number) => {
  return HTTP_CLIENT.delete(
    `${Endpoint.support.deleteSupportMessage}/${messageId}`
  );
};

export { GetAllSupportMessagesService, DeleteSupportMessageService };
